import { connect } from "react-redux";
import Lookup from "pages/guest/Lookup";
import { bindActionCreators } from "redux";
import * as AuthActions from "redux/actions/auth";
import * as UIActions from "redux/actions/ui";

const mapDispatchToProps = (dispatch: any) => {
  return {
    authActions: bindActionCreators(
      {
        ...AuthActions,
      },
      dispatch,
    ),
    uiActions: bindActionCreators(
      {
        ...UIActions,
      },
      dispatch,
    ),
  };
};

const mapStateToProps = (state: any) => {
  const { authStore } = state;
  return {
    authStore: { ...authStore },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Lookup);
